export const COLOR_DICTIONARY = [
  '#5467B2',
  '#BB62B0',
  '#7A67B6',
  '#6574C5',
  '#0083B1',
  '#1FA0D7',
  '#2866A8',
  '#6799E0',
];

export const materialListToColorDictionary = (materialsId: string[], colors: string[]): Record<string, string> =>
  materialsId.reduce(
    (acc, material, index) => ({ ...acc, [material]: colors[index % colors.length] }),
    {} as Record<string, string>,
  );
